import { Container } from 'aurelia-framework';
import { StorageService } from 'app/shared/lib/client-storage';

const DESCRIPTOR_DEFAULTS = {
    configurable: true,
    enumerable: true
}

function store(key: string, value: unknown) {
    try {
        const storage: StorageService = Container.instance.get(StorageService);
        storage.setValue('state', key, value);
    }
    catch(e) {
        console.log(Container.instance);
        console.log(StorageService);
        console.log(e);
    }
    //localStorage.setItem(key, JSON.stringify(value));
}

function retrieve(key: string): unknown {
    try {
        const storage: StorageService = Container.instance.get(StorageService);
        return storage.getValue('state', key);
    }
    catch(e) {
        console.log(Container.instance);
        console.log(StorageService);
        console.log(e);
        return undefined;
    }
    // const v = localStorage.getItem(key);
    // if (v === null) {
    //     return;
    // }
    // try {
    //     return JSON.parse(v!);
    // }
    // catch {
    //     return;
    // }
}

type PersistArguments = { key?: string, initialValue?: any };
export function persist({ key, initialValue: value }: PersistArguments) {
    return function persist(target: any, property: string, descriptor?: PropertyDescriptor): any {
        key = key || `${target.constructor.name}.${property}` as string;
        const persisted = retrieve(key);
        if(persisted !== undefined) {
            value = persisted;
        }
        if(descriptor !== undefined) {
            let { get, set } = descriptor;
            descriptor.get = function(this: any) {
                get && get.call(this);
                return value;
            };
            descriptor.set = function(this: any, v) {
                value = v;
                set && set.call(this, v);
                store(key!, value);
            };
        } else {
            descriptor = {
                get() { return value; },
                set(v: any) {
                    value = v;
                    store(key!, value);
                },
                ...DESCRIPTOR_DEFAULTS
            };
            Reflect.defineProperty(target, property, descriptor);
        }
        return descriptor;
    };
}
